import React from 'react';
import '../../css/Banner.css';


export default function Footer() {
  return (
      
    <div className='footerContainer' >
       <p>Copyright &copy; 2021</p>
       <p>Licensed by Markit : Dalhousie University</p>
      
    </div>
  );
}

